import React, {useState}  from 'react';
import _get from 'lodash/get';
import S from 'StyledBetHistoryTransactionItem.js';
import {MemoryRouter as Router, Route, Switch, NavLink, withRouter, Redirect, useHistory} from 'react-router-dom';
import useToggle from 'UseToggle.js'
import ModalOpacity from 'ModalOpacity.js';
import {formatDate} from 'helpers/datesHelper.js';
import {translation, redirect} from 'helpers/utilsHelper';
import {getTransactionResultStatusText} from 'helpers/transactionsHelper.js'
import betSlipTypes from 'betSlipTypes.enum.js';
import CashoutForm from 'CashoutForm.js';

const BetHistoryTransactionItem = ({
    transaction,
    transactionsList,
    currencyCode,
    index,
    cashouts,
    activeFreebets,
    prepareCashout,
    processCashout,
    refreshBetHistoryList,
    toggleAccountModal,
    toggleLiveCurtainForTxId,
    history
}) => {


    const {transactionId, regDate, stake, possibleReturn, cashoutCommisionAmount, confirmedReturn, bonus, statusCode, slipType, curtainActive = false, cashoutAmount, cashBackReturn, tax, transactionType} = transaction;
    const [showCashoutModal, toggleCashoutModal] = useToggle(false);
    const [showCashoutErrorModal, toggleCashoutErrorModal] = useToggle(false);
    const [cashoutErrorCode, setCashoutErrorCode] = useState('');
    const isCashoutBelowStake = confirmedReturn - cashoutCommisionAmount < stake  && statusCode == 5;
    const [maxAmount, setMaxAmount] = useState(0);

    // poprawić
    const getTransactionStatusClass = (statusCode, stake, confirmedReturn, pretty, cashBackReturn) => {
        let resultText = '';

        if (cashBackReturn) {
            return 'cashback';
        }


        if (statusCode == 2) {
            resultText = getTransactionResultStatusText(app.config.betIsWonIfConfirmedReturnIsGtZero,stake,confirmedReturn)
        } else {

            switch (statusCode) {
                case 0:
                    resultText = 'pending_acceptation';
                    break;
                case 1:
                    resultText = 'placed';
                    break;
                case 2 :
                    resultText = 'placed';
                    break;
                case 4 :
                case 10 :
                    resultText = 'cancel';
                    break;
                case 5 :
                    resultText = 'cashout';
                    break;
                default:
                    resultText = 'default';
                    break;
            }
        }

        if (pretty && resultText) {
            resultText = resultText.substring(0, 1).toUpperCase() + resultText.substring(1, resultText.length);
        }

        return resultText;
    };

    const toggleCashout = async(transactionId, e) => {

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation(); 
        try {
            const maxAmount = await prepareCashout(transactionId);
            setMaxAmount(maxAmount);
            toggleCashoutModal();
        } catch (errorCode) {
            setCashoutErrorCode(errorCode);
            toggleCashoutErrorModal();
        }
    };

    const checkCashout = (slipId) => {
        return (cashouts && cashouts.indexOf(slipId) !== -1);
    };

    const checkFreebet = (slipId) => {
        return (activeFreebets && activeFreebets.indexOf(slipId) !== -1);
    };

    const parseSlipType = (slipType) => {
        return betSlipTypes.getByType(slipType).name;
    };

    const redirectToTransactionDetails = (e,transactionId) => {
        e.stopPropagation();
        history.push('/'+transactionId);
    }

    const transactionStatusClass = getTransactionStatusClass(statusCode, stake, confirmedReturn, null, cashBackReturn);
    const cashoutFormProps = {
        toggleLiveCurtainForTxId,
        curtainActive,
        refreshBetHistoryList,
        transactionId,
        stake,
        possibleReturn,
        maxAmount,
        toggleCashoutModal,
        toggleCashoutErrorModal,
        prepareCashout,
        currencyCode,
        cachoutOnSubmit: processCashout,
        initialValues: {maximumAmount: maxAmount}
    };

    const renderCashoutOptions = () => {
        // if cashout is available display green button, if cashout was cashouted display green icon, any other option display gray icon
        if(checkCashout(transactionId) && !checkFreebet(transactionId)){
            return <S.CashoutIcon className={"availableCashout"} onClick={toggleCashout.bind(event, transactionId)}>{translation('account_betHistory_cashout')}</S.CashoutIcon>
        } else if(statusCode == 5) {
            return <S.CashoutIcon className={"cashouted"}></S.CashoutIcon>
        }
    }

    return ( transactionType !== 3943 && transactionType !== 3948 &&
        <S.BetHistoryItemWrapper className="bet-history-item-wrapper" onClick={(e) => redirectToTransactionDetails(e, transactionId)}>

            <ModalOpacity isOpen={showCashoutModal} toggleOpen={toggleCashoutModal} showHeaderIcon={false}
                          showHeader={false} padding="0px">
                <CashoutForm {...cashoutFormProps}></CashoutForm>
            </ModalOpacity>

            
            <ModalOpacity isOpen={showCashoutErrorModal} toggleOpen={toggleCashoutErrorModal} showHeaderIcon={false}
                          showHeaderTitle={false} padding="8px">
                <S.ErrorModal>
                    <S.ErrorModalTitle data-translation='account_betHistoryTransactionItem_cashout_error_title'>{translation('account_betHistoryTransactionItem_cashout_error_title')}</S.ErrorModalTitle>
                    <S.ErrorModalMessage data-translation={cashoutErrorCode ? `account_betHistoryTransactionItem_cashout_error_${cashoutErrorCode}` : `account_betHistoryTransactionItem_cashout_error_default`}>{cashoutErrorCode ? translation(`account_betHistoryTransactionItem_cashout_error_${cashoutErrorCode}`) : translation(`account_betHistoryTransactionItem_cashout_error_default`)}</S.ErrorModalMessage>
                </S.ErrorModal>
            </ModalOpacity>

            <S.BetHistoryItem className="bet-history-item">

                <div className={`transaction-status ${transactionStatusClass}`}>
                    <S.StatusIcon className={transactionStatusClass}></S.StatusIcon>
                </div>

                <div className="transaction-info">
                    <div className="transaction-type">
                        <span>{translation(parseSlipType(slipType))}</span>
                    </div>
                    <div className={`transaction-date${(process.env.CASHOUT) ? '-cashout' : ''}`}>
                        <span>{formatDate(regDate, 'HH:mm')}</span>
                    </div>
                </div>
                {process.env.CASHOUT && (<div className="transaction-cashout">
                    {renderCashoutOptions()}
                </div>)}

                <div className="transaction-cashback">
                    {transactionStatusClass === "cashback" && (
                        <S.StatusIcon className={transactionStatusClass}></S.StatusIcon>
                        )
                    }
                </div>
                
                <div className={`transaction-amount${(process.env.CASHOUT) ? '-cashout' : ''} ${transactionStatusClass}`}>
                    {stake.toFixed(2)}
                </div>

                <div className={`transaction-confirmed-win ${transactionStatusClass}`}>
                    {isCashoutBelowStake ? (confirmedReturn - cashoutCommisionAmount).toFixed(2) : confirmedReturn.toFixed(2)}
                </div>

{/*                 {process.env.BONUS_BET && (<div className="transaction-bonus">
                    {bonus}&nbsp;{currencyCode}
                </div>)} */}

            </S.BetHistoryItem>

        </S.BetHistoryItemWrapper>
    );
};


export default withRouter(BetHistoryTransactionItem);
